import React, { FunctionComponent } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Typography } from '@material-ui/core';
import SpecificationDisclaimer from '../../../../../../../common/components/presentation/SpecificationDisclaimer';
import { ISpecification } from '../../../../../../model/IVariantSpecifications';
import specificationsAccordionContentStyles from './specificationsAccordionContentStyles';

export interface ISpecificationsAccordionContentProps {
  specification: ISpecification;
}

const SpecificationsAccordionContent: FunctionComponent<ISpecificationsAccordionContentProps> = ({ specification }) => {
  const styles = specificationsAccordionContentStyles();
  const specData = specification.data[0];
  const key = specData.label;
  const isNested = key && key[0] === '+';

  return (
    <TableRow key={key} className={styles.tableRow} data-test={`specification:detail:${key}`}>
      <TableCell className={styles.tableCell} data-test="specification:category">
        <Typography variant="caption" component="p" className={isNested ? styles.nestedCaption : null}>
          {isNested ? key.substring(1) : key}
          {specData?.disclaimer && <SpecificationDisclaimer disclaimer={specData.disclaimer} />}
        </Typography>
      </TableCell>
      <TableCell className={styles.tableCell} data-test="specification.value">
        <Typography variant="caption" component="p">
          {specData.value}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default SpecificationsAccordionContent;
